import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTagIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.59961 0C6.26984 0.000123518 5.9698 0.131808 5.75391 0.347656L0.354492 5.74805C0.138561 5.96398 8.39233e-05 6.26973 0 6.59961C0 6.92961 0.132495 7.23029 0.354492 7.44629L4.55371 11.6455C4.76971 11.8675 5.07039 12 5.40039 12C5.73027 11.9999 6.03016 11.8673 6.24609 11.6514L11.6465 6.25195C11.8682 6.03008 11.9999 5.73009 12 5.40039V1.2002C12 0.540204 11.4598 0 10.7998 0H6.59961ZM8.5 2C9.32843 2 10 2.67157 10 3.5C10 4.32843 9.32843 5 8.5 5C7.67157 5 7 4.32843 7 3.5C7 2.67157 7.67157 2 8.5 2Z",
		fill: "#009ECF"
	})
});
export default SvgTagIcon;
